/**
 * This mixins contains some utils that can be used to handle selection of items in the list
 *
 * Pre-requisite: All the selectable item in the list should have class - selectable
 *
 */

import scrollToElement from '@/utils/scrollToElement'

export default {
  computed: {
    listContainer() {
      return this.listNode || this.$el
    }
  },
  methods: {
    selectFirst() {
      const firstItem = this.listContainer.querySelector('.selectable')
      firstItem && firstItem.classList.add('selected')
    },
    selectLast() {
      const allSelectableItems = this.listContainer.querySelectorAll('.selectable')
      if (allSelectableItems.length > 0)
        allSelectableItems[allSelectableItems.length - 1].classList.add('selected')
    },
    getSelected() {
      return this.listContainer.querySelector('.selectable.selected')
    },
    getSelectedId() {
      const selected = this.listContainer.querySelector('.selectable.selected')
      return selected?.dataset.id
    },
    emitSelected() {
      const selected = this.listContainer.querySelector('.selectable.selected')
      if (selected) {
        const id = selected.dataset.id
        const selectedItem = this.options.find(option => String(option.id) === String(id))
        this.$emit('select', selectedItem)
        return true
      }
    },
    scrollToSelectedElement() {
      const selected = this.listContainer.querySelector('.selectable.selected')
      selected && scrollToElement(selected)
    },
    selectNextItem() {
      const selected = this.listContainer.querySelector('.selectable.selected')
      if (selected) {
        const selectables = this.listContainer.querySelectorAll('.selectable')
        selected.classList.remove('selected')
        const currentIndex = Array.from(selectables).indexOf(selected)
        const nextSibling = currentIndex < selectables.length - 1 ? currentIndex + 1 : 0
        selectables[nextSibling].classList.add('selected')
      } else {
        this.selectFirst()
      }
      this.scrollToSelectedElement()
    },
    selectPreviousItem() {
      const selected = this.listContainer.querySelector('.selectable.selected')
      if (selected) {
        const selectables = this.listContainer.querySelectorAll('.selectable')
        selected.classList.remove('selected')
        const currentIndex = Array.from(selectables).indexOf(selected)
        const prevSibling = currentIndex > 0 ? currentIndex - 1 : selectables.length - 1
        selectables[prevSibling].classList.add('selected')
      } else {
        this.selectLast()
      }
      this.scrollToSelectedElement()
    }
  }
}
